import { memo } from "react";
import { Form, Input, Modal, Select, Typography } from "antd";

import { formatTrackerCurrency } from "../tracker.utils";
import { INVOICE_STATUS_FORM_OPTIONS } from "../tracker.constants";
import "../../../styles/trackon.css";

const { Text } = Typography;



function InvoiceStatusModalComponent({
  open,
  form,
  editRow,
  selectedInvoiceStatus,
  onOk,
  onCancel,
}) {
  return (
    <Modal
      title="Update Invoice Status"
      className="trackon-root"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={editRow ? "Update Status" : "Add"}
      width={560}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        {editRow && (
          <div style={{ marginBottom: 16, padding: "12px", backgroundColor: "#fafafa", borderRadius: 8 }}>
            <Text strong>Current Invoice Status:</Text>
            <Text style={{ display: "block", marginTop: 4 }}>{form.getFieldValue("invoiceStatus") || "-"}</Text>
            <Text strong style={{ display: "block", marginTop: 8 }}>
              Amount:
            </Text>
            <Text style={{ display: "block", marginTop: 4, color: "#1677ff" }}>
              {formatTrackerCurrency(editRow.milestoneAmount)}
            </Text>
          </div>
        )}

        <Form.Item
          label="Invoice Status"
          name="invoiceStatus"
          rules={[{ required: true, message: "Please select invoice status" }]}
        >
          <Select
            options={INVOICE_STATUS_FORM_OPTIONS}
            placeholder="Select invoice status"
            onChange={(value) => {
              if (value === "Invoiced") {
                form.setFieldValue("pendingReason", undefined);
              }
            }}
          />
        </Form.Item>
        {selectedInvoiceStatus !== "Invoiced" && (
          <Form.Item
            label="Reason / Notes"
            name="pendingReason"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const status = getFieldValue("invoiceStatus");
                  if ((status === "Pending Approval" || status === "Rejected") && !value) {
                    return Promise.reject(new Error("A reason is required for this status"));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.TextArea rows={3} placeholder="Explain the invoice status..." />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
}

export const InvoiceStatusModal = memo(InvoiceStatusModalComponent);
